import React, {useState,useEffect} from "react";
import { Col, Row, Card, CardBody, CardHeader, Container, Button, Modal, ModalHeader,Badge,Alert} from "reactstrap";
import Breadcrumbs from "../../../Components/Common/Breadcrumb";
import { subscribeToTokenRefresh } from "../../../helpers/Refreshfile";
import axios from "axios"
import { Link, useNavigate } from "react-router-dom"
import Select from "react-select";



const DomainManagement = () => {

const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
    if (reason === "clickaway") { return; }
    setAlertMsgg({ ...alertMsgg, open: false })
};
const [showloader, setshowloader] = useState(true);




const roleMap = { cst: "Customer", prt: "Partner", emp: "Employee" };
const navRolesOptions = [ { options: [ { label: roleMap["cst"], value: "cst" }, { label: roleMap["prt"], value: "prt" }, { label: roleMap["emp"], value: "emp" } ] } ];

const [domains, setDomains] = useState<any>([]);


const fetch_experts = async () => {
    try {
      setshowloader(true)
      const response = await axios.post(`accounts/handleadmdomains`, {render:true});
      console.log('response____ fetch_experts', response)
      if (response.status === "SENT") {
          setshowloader(false)

          const normalized = response.domains.map(domain => {
            domain.navroles = domain.navroles.map(role => ({ label: roleMap[role] || role, value: role })); 
            domain.navsubdomains = domain.navsubdomains.map(sub => { 
              sub.navroles = sub.navroles.map(role => ({ label: roleMap[role] || role, value: role })); 
              return sub;
            });
            return domain;
          });
          setDomains(normalized)

      }
    } catch (error:any) {
      if (error.response) {
          if ([401, 422].includes(error.response.status)) {
            console.log('Error in stripe payment')
            setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
          }
          else if (error.response.status === 403) {
            console.log('Error stripe payment')
              setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
              setTimeout(()=>{window.location.href="/logout"}, 2000)
          } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
          }
      } else {
        console.log('An error occurred')
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false)
    }           
}


const move__domain_content = async (cid:any=null, ocid:any=null, moveup:any=false) => {
  try{
    setshowloader(true);
    const formData = new FormData();
    formData.append('cid', cid);
    formData.append('ocid', ocid);
    formData.append('moveup', moveup);

    const response = await axios.post(`accounts/handledomainmovecontents`, formData, { withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' } });

    console.log('response_ move__domain_content___ ', response)
    if (response.status === "DONE") {
        // window.location.reload()
        setshowloader(false);
        fetch_experts();
    }
  } catch (error:any) {
      if (error.response) {
          if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); } 
          else if (error.response.status === 403) {
              setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
              setTimeout(()=>{window.location.href="/logout"}, 2000)
          } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
      } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
      setshowloader(false);
    }  
  
}

const move__subdomain_content = async (cid:any=null, ocid:any=null, moveup:any=false) => {
  try{
    setshowloader(true);
    const formData = new FormData();
    formData.append('cid', cid);
    formData.append('ocid', ocid);
    formData.append('moveup', moveup);

    const response = await axios.post(`accounts/handlesubdomainmovecontents`, formData, { withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' } });

    console.log('response_ move__subdomain_content___ ', response)
    if (response.status === "DONE") {
        // window.location.reload()
        setshowloader(false);
        fetch_experts();
    }
  } catch (error:any) {
      if (error.response) {
          if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); } 
          else if (error.response.status === 403) {
              setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
              setTimeout(()=>{window.location.href="/logout"}, 2000)
          } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
      } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
      setshowloader(false);
    }  
  
}




useEffect(() => {
  fetch_experts();
  subscribeToTokenRefresh(() => {
    console.log("🔁 Token refreshed. Re-fetching experts...");
    fetch_experts();
  });  
  
}, []);

const [showUndoModal, setShowUndoModal] = useState(false);

useEffect(() => {
  if (!showUndoModal) return;

  const interval = setInterval(() => {
    setCountdown((prev) => {
      if (prev <= 1) {
        clearInterval(interval);
        setShowUndoModal(false);
        return 0;
      }
      return prev - 1;
    });
  }, 1000);

  return () => clearInterval(interval); // cleanup
}, [showUndoModal]);

const [lastDeletedItem, setLastDeletedItem] = useState<any>(null);
const [managedomain, setmanagedomain] = useState(false);
const [selecteddomain, setselecteddomain] = useState<any>(null);
const [countdown, setCountdown] = useState(10);

const [error, setErros] = useState({name : '',navroles: ''})
const add_domain = async (did:any=null, push:any=false) => {
  console.log("selecteddomain____________", selecteddomain)
  try{
      if (push){
        const newErros: any = {};
        if(!selecteddomain?.name || selecteddomain?.name.trim() === "") newErros.name = 'Domain name is required!'
        // if(!Array.isArray(selecteddomain?.navroles) || selecteddomain.navroles.length === 0) newErros.navroles = 'Domain role is required!'

        if(Object.keys(newErros).length > 0){
          setErros(newErros)
          return
        }
        const isEdit = !!selecteddomain?.id;
        setshowloader(true)
        // action: selecteddomain?.id ? "edit" : "add"
        const response = await axios.post(`accounts/handleadmdomains`, {action: isEdit ? "edit" : "add", isdom:true, name:selecteddomain.name, iconclass:selecteddomain.iconclass, roles:selecteddomain.navroles, did:selecteddomain?.id});
        console.log('response____ add_domain', response)
        if (response.status === "DONE") {
              setshowloader(false)
              setmanagedomain(false);
              setselecteddomain(false);
              setErros({ name: '', navroles: '' });
              fetch_experts(); 
              setAlertMsgg({...alertMsgg,open: true,content:isEdit ? "Domain updated successfully!" : "Domain created successfully!",type: "success",});
              setTimeout(() => {
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 4000);
            }
        return null
      }
    setselecteddomain(null)
    setselecteddomain( (domains.filter((domain:any) => (domain.id==did)))[0] )
    console.log("Adding domain here", (domains.filter((domain:any) => (domain.id==did))), selecteddomain)
    setmanagedomain(true)
    setErros({ name: '', navroles: '' });
  }catch (error:any) {
          if (error.response) {
              if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); } 
              else if (error.response.status === 403) {
                  setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                  setTimeout(()=>{window.location.href="/logout"}, 2000)
              } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
          } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
          setshowloader(false);
      }
}

const [managesubdomain, setmanagesubdomain] = useState(false);
const [selectedsubdomain, setselectedsubdomain] = useState<any>(null);
const [suberror, setsubErros] = useState({name : '',navroles: ''})
const add_subdomain = async (did:any=null, sdid:any=null, push:any=false) => {
  console.log("selectedsubdomain____________", selectedsubdomain)
  try{
      if (push){
        const newErros : any = {}
        if(!selectedsubdomain?.name || selectedsubdomain?.name.trim() === "") newErros.name = 'Subdomain name is required!'
        // if(!Array.isArray(selectedsubdomain?.navroles) || selectedsubdomain.navroles.length === 0) newErros.navroles = 'Subdomain role is required!'

        if(Object.keys(newErros).length > 0){
          setsubErros(newErros)
          return
        }

        const isEdit = !!selectedsubdomain?.id;
        // action: selectedsubdomain?.id ? "edit" : "add"
        setshowloader(true)
        const response = await axios.post(`accounts/handleadmdomains`, {action: isEdit ? "edit" : "add", isdom:false, name:selectedsubdomain.name, iconclass:selectedsubdomain.iconclass, roles:selectedsubdomain.navroles, sdid:selectedsubdomain?.id, did:selectedsubdomain?.did});
        console.log('response____add_subdomain ', response)
        if (response.status === "DONE") {
            setshowloader(false);
            setmanagesubdomain(false);
            setselectedsubdomain(false);
            setsubErros({ name: '', navroles: '' });
            fetch_experts(); 
            setAlertMsgg({...alertMsgg,open: true,content:isEdit ? "Subdomain updated successfully!" : "Subdomain created successfully!",type: "success",});
            setTimeout(() => {
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 4000);
          }
        return null
      }
      setselectedsubdomain(null)
      setselectedsubdomain({ ...domains.filter((domain:any) => (domain.id==did))[0].navsubdomains.filter((subdomain:any) => (subdomain.id==sdid))[0], did: did })
      console.log("Adding subdomain here", selectedsubdomain)
      setmanagesubdomain(true)
      setsubErros({ name: '', navroles: '' });
    }catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); } 
            else if (error.response.status === 403) {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
        } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
        setshowloader(false);
    }
}



const [managedelete, setmanagedelete] = useState(false);
const [selecteddelete, setselecteddelete] = useState<any>(null);

const handle_delete = async (did:any=null, sdid:any=null, push:any=false) => {
  console.log('selecteddelete',selecteddelete)
  try{
      if (push){
        setshowloader(true)
        const response = await axios.post(`accounts/handleadmdomains`, {action: "delete", isdom: selecteddelete[1] == "domain", sdid:selecteddelete[0].id, did:selecteddelete[0].id});
        console.log('response____ handle_delete', response)
        if (response.status === "DONE") {
            setmanagedelete(false); 
            setshowloader(false);
            setselecteddelete(false);
            fetch_experts();   

            console.log('check Domain last delete id ',selecteddelete[0])
            setLastDeletedItem({
              item: selecteddelete[0],  
              type: selecteddelete[1]   
            });
            // setCountdown(10);
            // setShowUndoModal(true);
            // setTimeout(() => {
            //   setShowUndoModal(false); 
            // }, 10000);
            setAlertMsgg({...alertMsgg,open: true,content: selecteddelete[1] === "domain"? "Domain Deleted successfully!":"Subdomain deleted successfully!",type: "success",});
            setTimeout(() => {
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 4000);
          }
        return null
      }

    setselecteddelete(null)
    if (sdid){
      setselecteddelete( [domains.filter((domain:any) => (domain.id==did))[0].navsubdomains.filter((subdomain:any) => (subdomain.id==sdid))[0], "subdomain"] )
    }else{
      setselecteddelete([(domains.filter((domain:any) => (domain.id==did)))[0], "domain"])
    }
    console.log("Adding delete here")
    setmanagedelete(true)
  }catch (error:any) {
      if (error.response) {
          if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); } 
          else if (error.response.status === 403) {
              setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
              setTimeout(()=>{window.location.href="/logout"}, 2000)
          } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
      } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
      setshowloader(false);
  }
}


// const handleUndoDelete = async () => {
//   try{
//     setshowloader(true)
//     if (!lastDeletedItem) return;
//     console.log('lastDeletedItem chekc the id ',lastDeletedItem)
//     const isDomain = lastDeletedItem.type === "domain";
//     const response = await axios.post(`accounts/handleadmdomains`, {
//         action: "restore",
//         isdom: isDomain,
//         did: isDomain ? lastDeletedItem.item.id : null,
//         sdid: !isDomain ? lastDeletedItem.item.id : null,
//       });

//     if (response.status === "DONE") {
//       fetch_experts();
//       setShowUndoModal(false);
//       setLastDeletedItem(null);
//       setshowloader(false);
//     }
//   }catch (error:any) {
//       if (error.response) {
//           if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); } 
//           else if (error.response.status === 403) {
//               setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
//               setTimeout(()=>{window.location.href="/logout"}, 2000)
//           } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
//       } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
//       setshowloader(false);
//   }
// };

document.title = "Domain and Subdomains";
const navigate = useNavigate();
return (
    <React.Fragment>
    <div className="page-content">

        {/* {showUndoModal && (
          <div className="undoModal show bg-light p-3 rounded shadow-sm">
            <h4 className="font-size-15 text-dark mb-1">Oops? Made a mistake?</h4>
            <p className="mb-2 font-size-12 text-dark">
              Your last action has been saved, but you can undo it for the next <strong>{countdown}</strong> seconds.
            </p>
            <Button
              color="dark"
              className="btn btn-sm me-2 mb-sm-0 mb-2"
              onClick={handleUndoDelete}
            >
              <i className="bx bx-rotate-left font-size-12 align-middle me-1"></i> Undo
            </Button>
          </div>
        )} */}

        {alertMsgg.open && (
        <Alert
        color={alertMsgg.type === "success" ? "success" : "danger"}
        toggle={handleAlertMsggClose}
        style={{ fontWeight: "bold" }}
        >
        {alertMsgg.content}
        </Alert>
        )}
        <div className="loaderContainer" hidden={!showloader}>
          <div className="spinner">
          <div></div>  
          <div></div>    
          <div></div>    
          <div></div>    
          <div></div>    
          <div></div>    
          <div></div>    
          <div></div>    
          <div></div>    
          <div></div>    
      </div>
    </div>
        <Container fluid={true}>
        <Breadcrumbs title="Domains" breadcrumbItem="Domain and Subdomains Management" />
        <Row>
            <Col>
            <Row>
              <div className="text-sm-end">
                <Button color="primary" className="btn btn-secondary btn-md mb-3 me-2" data-toggle="button" aria-pressed="false" onClick={add_domain}> <i className="bx bxs-add-to-queue font-size-16 align-middle me-2"></i>{" "} Add New Domain</Button>
                <Link to="/recyclebin" color="primary" className="btn btn-danger btn-md mb-3"> <i className="bx bx-sync font-size-16 align-middle me-2"></i> Recover Domains</Link>
               
              </div>
            </Row>

            {/* modal for add/edit domains */}
            <Modal isOpen={managedomain} centered toggle={() => { setmanagedomain(!managedomain) }}>
              <ModalHeader className="modal-header" toggle={() => { setmanagedomain(!managedomain) }}> 
                <div className="h5 modal-title" id="adddomainpopup">{selecteddomain?.id ? "Edit" : "Add"} Domain</div>
              </ModalHeader>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label htmlFor="message-text" className="col-form-label">Name<span className="text-danger px-1">*</span></label>
                    <textarea  className={`form-control ${error.name ? 'is-invalid' : ''}`}  id="message-dtext" value={selecteddomain ? selecteddomain.name : ""} required onChange={(e) => { setselecteddomain({ ...selecteddomain, name: e.target.value });
                  setErros((prev) => ({ ...prev, name: '' }));
                   }} />
                  {error.name && <div className="invalid-feedback">{error.name}</div>}
                  </div>
                  <div className="mb-3">
                    <label className="control-label">Roles</label>
                    <Select
                      value={selecteddomain ? selecteddomain.navroles : null}
                      isMulti={true}
                      onChange={(e:any) => { setselecteddomain({ ...selecteddomain, navroles: e })
                    setErros((prev) => ({ ...prev,navroles: '' }));
                   }}
                      options={navRolesOptions}
                      // className="select2-selection"
                      className={`select2-selection ${error.navroles ? 'is-invalid is-invalid-custom' : ''}`}
                    />
                    {/* {error.navroles && <small className="text-danger">{error.navroles}</small>} */}
                    {error.navroles && <div className="invalid-feedback">{error.navroles}</div>}
                  </div>
                  <div className="mb-3">
                    <label htmlFor="message-text" className="col-form-label">IconClass(optional):</label>
                    <i className={`${selecteddomain?.iconclass} font-size-16 align-middle m-2`}></i>{" "}
                    <textarea  className="form-control"  id="message-diconclass" value={selecteddomain ? selecteddomain.iconclass : ""} required onChange={(e) => { setselecteddomain({ ...selecteddomain, iconclass: e.target.value }) }} /> 
                    <a href="/icons-boxicons" target="_blank">Click here to view icons</a>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => { setmanagedomain(!managedomain) }}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={() => add_domain(null, true)}>Save</button>
              </div>
            </Modal>

            {/* modal for add/edit subdomains */}
            <Modal isOpen={managesubdomain} centered toggle={() => { setmanagesubdomain(!managesubdomain) }}>
              <ModalHeader className="modal-header" toggle={() => { setmanagesubdomain(!managesubdomain) }}> 
                <div className="h5 modal-title" id="addsubdomainpopup">{selectedsubdomain?.id ? "Edit" : "Add"} SubDomain</div>
              </ModalHeader>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label htmlFor="message-text" className="col-form-label">Domain<span className="text-danger px-1">*</span></label>
                    <select className="form-control" value={selectedsubdomain?.did ? selectedsubdomain.did : ""} 
                    id="filter_subcat" name="filter_subcat"
                    onChange={ (e) => { setselectedsubdomain({  ...selectedsubdomain, did: e.target.value }) }} >
                      {domains.map((domain:any, index:any)=>(
                          <option key={domain.id} value={domain.id}>{domain.name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="message-text" className="col-form-label">Name<span className="text-danger px-1">*</span></label>
                    <textarea  className={`form-control ${suberror.name ? 'is-invalid' : ''}`}  id="message-sdtext" value={selectedsubdomain ? selectedsubdomain.name : ""} required onChange={(e) => { setselectedsubdomain({ ...selectedsubdomain, name: e.target.value });
                    setsubErros((prev) => ({ ...prev, name: '' }));
                   }} />
                   {suberror.name && <div className="invalid-feedback">{suberror.name}</div>}
                  </div>

                  
                  <div className="mb-3">
                    <label className="control-label">Roles</label>
                    <Select
                      value={selectedsubdomain ? selectedsubdomain.navroles : null}
                      isMulti={true}
                      onChange={(e:any) => { setselectedsubdomain({ ...selectedsubdomain, navroles: e });
                    setsubErros((prev) => ({ ...prev, navroles: '' })); }}
                      options={navRolesOptions}
                      // className="select2-selection"
                      className={`select2-selection ${suberror.navroles ? 'is-invalid is-invalid-custom' : ''}`}
                    />
                    {/* {suberror.navroles && <small className="text-danger">{suberror.navroles}</small>} */}
                    {suberror.navroles && <div className="invalid-feedback">{suberror.navroles}</div>}
                  </div>

                  <div className="mb-3">
                    <label htmlFor="message-text" className="col-form-label">IconClass(optional):</label>
                    <i className={`${selectedsubdomain?.iconclass} font-size-16 align-middle m-2`}></i>{" "}
                    <textarea  className="form-control"  id="message-sdiconclass" value={selectedsubdomain ? selectedsubdomain.iconclass : ""} required onChange={(e) => { setselectedsubdomain({ ...selectedsubdomain, iconclass: e.target.value }) }} />
                    <a href="/icons-boxicons" target="_blank">Click here to view icons</a>
                  </div>

                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => { setmanagesubdomain(!managesubdomain) }}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={() => add_subdomain(null, null, true)}>Save</button>
              </div>
            </Modal>

            {/* modal for deleting domain/subdomains */}
            <Modal isOpen={managedelete} centered toggle={() => { setmanagedelete(!managedelete) }}>
              <ModalHeader className="modal-header" toggle={() => { setmanagedelete(!managedelete) }}> 
                <div className="h5 modal-title" id="adddeletepopup">Delete {selecteddelete ? selecteddelete[1] : null}</div>
              </ModalHeader>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label htmlFor="message-text" className="col-form-label">Are you sure you want to delete "{selecteddelete ? selecteddelete[0]?.name : null}"</label>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-soft-dark" data-bs-dismiss="modal" onClick={() => { setmanagedelete(!managedelete) }}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={() => handle_delete(null, null, true)}>Delete</button>
              </div>
            </Modal>
            
            <Row>
              {domains && domains.map((domain:any, domainindex) => (
                <Col className="" md={12} key={domainindex}>

                  <Card key={domainindex} className="rounded-4 border border-dark-shade card overflow-hidden">
                    <CardHeader className="bg-light-grey border-bottom border-dark-shade text-uppercase">
                      <div className="d-sm-flex justify-content-between align-items-center py-2">
                        <div className="d-flex align-items-center mb-sm-0 mb-2">
                          <i className={`${domain?.iconclass} font-size-16 align-middle m-2`}></i>{" "}
                          <h3 className="text-dark text-capitalize mb-0 font-size-17">{domain.name}</h3>
                          <div className="ms-2">
                            {domain.navroles.length ? (
                            domain.navroles.map((navrole:any) => (
                            <Badge pill className="me-1 font-size-12 fw-normal bg-purple text-uppercase"> {navrole.label} </Badge>))) : <Badge pill className="me-1 font-size-12 fw-normal bg-purple text-uppercase"> (no role selected) </Badge>}
                          </div>
                        </div>
                        <div className="text-sm-end ps-sm-0 ps-2 ">
                          <Button color="dark" className="btn btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => add_domain(domain.id)}> <i className="bx bx-pencil font-size-11 align-middle me-1"></i>{" "} Edit</Button>
                          <Button color="danger" className="btn btn-primary btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => handle_delete(domain.id, null)}> <i className="bx bx-trash font-size-11 align-middle me-1"></i>{" "} Delete</Button>
                          <Button color="primary" className="btn btn-primary btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => add_subdomain(domain.id)}> <i className="bx bxs-add-to-queue font-size-11 align-middle me-1"></i>{" "} Add SubDomain</Button>
                          <Button color="secondary" className="btn btn-primary btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => navigate(`/managePlans?domain=${domain.id}`, { state: { domainName: domain.name } })}> <i className="bx bx-dollar font-size-11 align-middle me-1"></i>{" "} Manage Plans</Button>
                          <Button color="info" className="btn btn-primary btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => navigate(`/ragDocuments?domain=${domain.id}`)}> <i className="bx bx-file font-size-11 align-middle me-1"></i>{" "} RAG Documents</Button>
                          <Button disabled={domainindex == 0} color="dark" className="btn btn-primary btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => move__domain_content(domain.id, (domainindex ? domains[domainindex-1].id : null), true)}> <i className="bx bx-chevrons-up font-size-16 align-middle me-2"></i>{" "} Move Up</Button>
                          <Button disabled={domainindex == (domains.length-1)} color="dark" className="btn btn-primary btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => move__domain_content(domain.id, (domainindex+1 ? domains[domainindex+1].id : null), false)}> <i className="bx bx-chevrons-down font-size-16 align-middle me-2"></i>{" "} Move Down</Button>
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody>
                      {/* <CardTitle tag="h4" className="mt-0">
                      </CardTitle> */}
                      <h5 className="mb-3">SubDomains:</h5>
                      <Row>
                        {domain.navsubdomains && domain.navsubdomains.map( (subdomain:any, subdomainindex) => ( 
                          <Col md={6} lg={4} key={subdomainindex} className="mb-3">
                            
                            <div className="">
                                  <div >
                                    <div className="border boxSubdomain p-4 rounded-4 shadow-sm">
                                      <div className="text-start floatRoles">
                                        {subdomain.navroles.length ? (
                                        subdomain.navroles.map((navrole:any) => (
                                        <Badge pill className="me-1 font-size-12 fw-normal bg-purple text-uppercase"> {navrole.label} </Badge>))) : <Badge pill className="me-1 font-size-12 fw-normal bg-purple text-uppercase"> (no role selected) </Badge>}
                                      </div>
                                      <p className="font-size-18 fw-medium mb-3 text-capitalize text-dark">
                                        <i className={`${subdomain?.iconclass} font-size-16 align-middle m-2`}></i>{" "}
                                        {subdomain.name}
                                      </p>
                                      <div className="d-flex gap-2 flex-wrap">
                                        <Button color="dark" className="btn btn-sm mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => add_subdomain(domain.id, subdomain.id)}> <i className="bx bx-pencil font-size-11 align-middle me-1"></i>{" "} Edit</Button>
                                        
                                        <Button color="danger" className="btn btn-primary btn-sm mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => handle_delete(domain.id, subdomain.id)}> <i className="bx bx-trash font-size-11 align-middle me-1"></i>{" "} Delete</Button>

                                        <Link to={`/ncontents/${subdomain.id}`} color="success" className="btn btn-primary btn-sm mb-sm-0 mb-2">
                                          <i className="bx bxs-component font-size-11 align-middle me-1"></i>{" "} Manage Content
                                        </Link>
                                      <Button disabled={subdomainindex == 0} color="dark" className="btn btn-primary btn-sm mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => move__subdomain_content(subdomain.id, (subdomainindex ? domain.navsubdomains[subdomainindex-1].id : null), true)}> <i className="bx bx-chevrons-up font-size-16 align-middle me-2"></i>{" "} Move Up</Button>
                          <Button disabled={subdomainindex == (domain.navsubdomains.length-1)} color="dark" className="btn btn-primary btn-sm mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => move__subdomain_content(subdomain.id, (subdomainindex+1 ? domain.navsubdomains[subdomainindex+1].id : null), false)}> <i className="bx bx-chevrons-down font-size-16 align-middle me-2"></i>{" "} Move Down</Button>
                                      </div>

                                    </div>
                                  </div>
                              </div>
                          </Col>
                        ))}
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
            </Col>
        </Row>
        </Container>
    </div>
    </React.Fragment>
);

};
export default DomainManagement;
